<template>
  <v-card class="result_card">
    <v-layout row wrap>
      <v-flex xs12 md6 lg6 >
        <v-card-title primary-title>
          <div>
            <span class="result_title_star subheading primary--text" >
              <a href="#" onClick="return false;"
                    slot="activator"
                    v-if="displayShowDocument"
                    @click="showEntity(result.objectID); onClickOpen('click-showmore', result.objectID, result.entity_name)"
                  ><ais-highlight :result="result" attribute-name="entity_name"></ais-highlight>
              </a>
            </span>
            <sup v-if="result.TFWA != undefined && result.TFWA.length !== 0" ><span v-text="result.TFWA[0][0]" /></sup>
            <div>
              <span v-if="result.entity_types" >Type<span v-if="result.entity_types.length > 1">s</span>: <span v-text="result.entity_types.join(', ')" /><br/></span>

              <span v-if="result.Retailer_hierarchy !== undefined
                && result.Retailer_hierarchy.length !== 0
                && result.Retailer_hierarchy.lvl0 !== undefined
                && result.Retailer_hierarchy.lvl0.length !== 0
                && result.Retailer_hierarchy.lvl0[0] !== result.entity_name" >
                  Related to {{ result.Retailer_hierarchy.lvl0[0] }} <br/></span>

                <span v-if="result.Supplier_hierarchy !== undefined
                && result.Supplier_hierarchy.length !== 0
                && result.Supplier_hierarchy.lvl0 !== undefined
                && result.Supplier_hierarchy.lvl0.length !== 0
                && result.Supplier_hierarchy.lvl0[0] !== result.entity_name" >
                Related to {{ result.Supplier_hierarchy.lvl0[0] }} <br/></span>



              <!-- <span v-if="result.entity_types">
                <v-chip
                  v-for="entity_type in result.entity_types"
                  :key="entity_type"
                  small
                  text-color="white"
                  color="primary">
                  {{ entity_type }}
                </v-chip>
              </span> -->
              <span v-if="result.Tags != undefined && result.Tags.length !== 0">
                <v-chip
                  v-for="tag in result.Tags[0]"
                  :key="tag"
                  small
                  text-color="white"
                  color="orange">
                  {{ tag }}
                </v-chip>
                <!-- <br/> -->
              </span>
              <!-- <span v-if="result.URL" ><a target="_blank" :href="result.URL[0][0]" v-text="result.URL[0][0]" /><br/></span> -->
            </div>
          </div>
        </v-card-title>
      </v-flex>
      <!-- <v-flex xs12 md6 lg6 >
        <v-btn small slot="activator" class="primary white--text" v-if="result.URL"
          target="_blank" :href="result.url" @click.native="onClickOpen('click-open', result.objectID, result.title)">
          <v-icon dark class="btn_icone">open_in_new</v-icon>
          Open
        </v-btn>
      </v-flex> -->
    </v-layout>
  </v-card>
</template>

<script>
import format from 'date-fns/format'
import fromUnixTime from 'date-fns/fromUnixTime'
import resultPanelConstructor from '../ResultPanelConstructor'
import { mapMutations } from 'vuex'
import USER from '@/graphql/User.gql'
import LOGGER from '@/graphql/Logger.gql'

export default {
  name: 'press-result-panel',
  extends: resultPanelConstructor,
  data () {
    return {
      user: false,
      attachment_path: process.env.VUE_APP_ATTACHMENT_PATH,
      algolia_wiki_index_name: process.env.VUE_APP_ALGOLIA_WIKI_INDEX_NAME,
      format,
      fromUnixTime
    }
  },
  computed: {
  },
  methods: {
    ...mapMutations(['addError']),
    ...mapMutations('wiki', ['setEntityId', 'setViewedEntityDialog']),
    async showEntity (id) {
      await this.setEntityId(id)
      this.setViewedEntityDialog(true)
    },
    onClickOpen (action, objectId, title) {
      this.$apollo.mutate({
        mutation: LOGGER,
        variables: {
          level: 'info',
          message: JSON.stringify({
            module: this.$route.name,
            action,
            objectId,
            title
          })
        }
      })
    }
  },
  apollo: {
    user: {
      query: USER
    }
  }
}
</script>
<style>
</style>
